// extracted by mini-css-extract-plugin
export default {"advertCardHeader":"c-a_iz","advertCardHeader__actions":"c-a_iA","advertCardHeader__bottomLabel":"c-a_iB"};